require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-bootstrap-add-font-awesome-icons-to-all-of-our-buttons.json") })
        }
      }, "path---front-end-libraries-bootstrap-add-font-awesome-icons-to-all-of-our-buttons");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-bootstrap-add-font-awesome-icons-to-all-of-our-buttons!./.cache/json/front-end-libraries-bootstrap-add-font-awesome-icons-to-all-of-our-buttons.json
// module id = 1996
// module chunks = 231608221292675